import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import { isMobile } from 'react-device-detect';

const cloudyFadeOutLeft = keyframes`
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    filter: blur(10px);
  }
`;

export const ContentWrapper = styled(Box)({
  height: '100vh',
  maxHeight: 'calc(100vh - 40px)',
  width: '100%',
  padding: '12px 15px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const EstimationTimeWrapper = styled(Box)({
  width: '80%',
  height: '238px',
  borderRadius: '14px',
  marginTop: '64px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
});

export const TimeSectionWrapper = styled(Box)({
  width: '90%',
  height: '70px',
  borderRadius: '14px',
  backdropFilter: 'blur(2pxx)',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
});

export const EstimatedText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
});

export const TimeText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 700,
});

export const UploadNotificationWrapper = styled(Box)({
  marginTop: isMobile ? '' : '145px',
  position: 'absolute',
  bottom: '35%',
});

export const FadeOutWrapper = styled('div')<{ $fadeOut?: boolean }>(({ $fadeOut }) => ({
  ...($fadeOut && {
    animation: `${cloudyFadeOutLeft} 1.5s ease-out forwards`,
    opacity: 1,
  }),
}));
